// Returns a getter for a page's hero text (eyebrow/title/desc), preferring the
// admin-configured override in settings.page_hero_texts, falling back to the
// built-in i18n wording for the current language.
export function heroText(settings, pageKey, lang, t, prefix) {
  const o = (settings && settings.page_hero_texts && settings.page_hero_texts[pageKey] && settings.page_hero_texts[pageKey][lang]) || {};
  return (k) => (o[k] != null && o[k] !== "" ? o[k] : t(`${prefix}.${k}`));
}
